import React from 'react';
import { Filter, ReferenceInput, SelectInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const SurveyReportsFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Survey" source="pack_id" reference="admin/surveys" alwaysOn>
      <SelectInput optionText={(s) => `(${s.id}) ${s.name}`} />
    </ReferenceInput>
    <UserAutocompleteInput label="User ID" source="user_id" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default SurveyReportsFilter;
